"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickFreeModuleSalesConfigSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickFreeModuleSalesConfigSchema extends baseClickSchema_1.BaseClickSchema {
    constructor() {
        super({ componentName: 'FreeModuleModalSalesConfigButton' });
        this.action = baseSchema_1.ActionsName.CLICK_FREE_MODULE_CONFIG;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action
        };
    }
}
exports.ClickFreeModuleSalesConfigSchema = ClickFreeModuleSalesConfigSchema;
